import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Sparkles, Trophy } from 'lucide-react';

interface Props {
  notification: {
    _id: string;
    title: string;
    message: string;
    pointsEarned?: number;
  } | null;
  onClose: () => void;
}

const CelebrationModal: React.FC<Props> = ({ notification, onClose }) => {
  useEffect(() => {
    if (!notification) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [notification, onClose]);

  return (
    <AnimatePresence>
      {notification && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 11000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.75)',
            backdropFilter: 'blur(10px)',
            padding: '16px',
          }}
          onClick={onClose}
        >
          <motion.div
            role="dialog"
            aria-modal="true"
            initial={{ scale: 0.85, y: 30, opacity: 0 }}
            animate={{ scale: 1, y: 0, opacity: 1 }}
            exit={{ scale: 0.9, y: 20, opacity: 0 }}
            transition={{ type: 'spring', damping: 20, stiffness: 260 }}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: '100%',
              maxWidth: '420px',
              borderRadius: '24px',
              padding: '40px 32px',
              textAlign: 'center',
              background: 'linear-gradient(160deg, rgba(15,23,42,0.98), rgba(6,78,59,0.35))',
              border: '1px solid var(--accent-primary-glow)',
              boxShadow: '0 30px 80px rgba(0,0,0,0.5), 0 0 60px var(--accent-primary-soft)',
            }}
          >
            <motion.div
              animate={{ rotate: [0, -8, 8, 0], scale: [1, 1.08, 1] }}
              transition={{ duration: 1.2, repeat: 2 }}
              style={{
                width: 72,
                height: 72,
                margin: '0 auto 20px',
                borderRadius: '20px',
                background: 'var(--gradient-logo)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Trophy size={36} color="white" />
            </motion.div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: 8 }}>
              <Sparkles size={16} color="var(--accent-primary)" />
              <span style={{ color: 'var(--accent-primary)', fontWeight: 700, fontSize: 13, letterSpacing: '0.04em' }}>TEBRİKLER</span>
            </div>
            <h2 style={{ margin: '0 0 10px', color: 'white', fontSize: '1.4rem', fontWeight: 800 }}>{notification.title}</h2>
            <p style={{ margin: '0 0 20px', color: '#94a3b8', lineHeight: 1.6 }}>{notification.message}</p>
            {notification.pointsEarned ? (
              <motion.p
                initial={{ scale: 0.5, opacity: 0 }}
                animate={{ scale: 1, opacity: 1 }}
                transition={{ delay: 0.2, type: 'spring' }}
                style={{
                  margin: '0 0 24px',
                  fontSize: '2rem',
                  fontWeight: 900,
                  background: 'var(--gradient-logo)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                +{notification.pointsEarned} puan
              </motion.p>
            ) : null}
            <button
              type="button"
              onClick={onClose}
              style={{
                padding: '14px 28px',
                borderRadius: '12px',
                border: 'none',
                background: 'var(--gradient-primary)',
                color: 'white',
                fontWeight: 700,
                cursor: 'pointer',
                fontSize: '15px',
              }}
            >
              Harika!
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CelebrationModal;
